import { render } from "./blogTagView.vue?vue&type=template&id=24ecb386"
import script from "./blogTagView.vue?vue&type=script&lang=js"
export * from "./blogTagView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__